<template>
	<div>
		<div class="container">
			<div class="handle-box">
				<el-select size="small" v-model="query.sourceId" placeholder="请选择来源" @change="handleSourceChange" style="width: 200px; margin-right: 10px;">
					<el-option v-for="item in sourceList" :key="item.id" :label="item.sourceName" :value="item.id"></el-option>
				</el-select>
				<el-input size="small" v-model="query.phoneNumber" placeholder="搜索号码" style="width: 200px; margin-right: 10px;"
					@keyup.enter="getData"></el-input>
				<el-button size="small" type="primary" :class="[theme]" @click="getData">搜索</el-button>
				<el-button size="small" type="primary" :class="[theme]" @click="handleAdd" v-if="isAdmin">添加号码</el-button>
				<el-button size="small" type="primary" :class="[theme]" @click="handleBatchAdd" v-if="isAdmin">批量添加</el-button>
				<el-button size="small" type="danger" @click="handleBatchDeleteByPhones" v-if="isAdmin">批量删除</el-button>
				<el-button size="small" type="danger" @click="handleBatchDelete" v-if="isAdmin">清空号码</el-button>
			</div>
			<el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header"
				max-height="600" :row-style="{ height: '20px' }" :cell-style="{ padding: '6px' }"
				:header-cell-style="{ 'text-align': 'center' }" stripe v-loading="loading">
				<el-table-column prop="sourceName" label="来源名称" align="center" show-overflow-tooltip></el-table-column>
				<el-table-column prop="phoneNumber" label="号码" align="center" show-overflow-tooltip></el-table-column>
				<el-table-column prop="createdAt" label="创建时间" align="center" width="160"></el-table-column>
				<el-table-column label="操作" width="190" align="center">
					<template #default="scope">
						<el-button size="small" type="text" icon="el-icon-edit" @click="handleEdit(scope.row)">编辑</el-button>
						<el-button size="small" type="text" icon="el-icon-delete" style="color: #f56c6c;"
							@click="handleDelete(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination">
				<el-pagination background layout="total, prev, pager, next" :current-page="query.pageIndex"
					:page-size="query.pageSize" :total="pageTotal" @current-change="handlePageChange">
				</el-pagination>
			</div>
		</div>
		<el-dialog :title="title" v-model="addVisible" width="520px" @close="closeDialog">
			<el-form label-width="100px" :model="addForm" ref="editForm">
				<el-form-item label="来源" prop="sourceId" v-if="title == '添加'">
					<el-select v-model="addForm.sourceId" placeholder="请选择来源" style="width: 100%;" :disabled="title == '修改'">
						<el-option v-for="item in sourceList" :key="item.id" :label="item.sourceName" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="号码" prop="phoneNumber">
					<el-input size="small" v-model="addForm.phoneNumber" placeholder="请输入号码"></el-input>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="closeDialog">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" v-if="title == '添加'"
						@click="submitAdd">确定</el-button>
					<el-button size="small" type="primary" :class="[theme]" v-if="title == '修改'"
						@click="submitUpload">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="批量添加号码" v-model="batchAddVisible" width="600px" @close="closeBatchAddDialog">
			<el-form label-width="100px" :model="batchAddForm">
				<el-form-item label="来源">
					<el-select v-model="batchAddForm.sourceId" placeholder="请选择来源" style="width: 100%;">
						<el-option v-for="item in sourceList" :key="item.id" :label="item.sourceName" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="号码列表">
					<el-input size="small" type="textarea" v-model="batchAddForm.phoneNumbers" 
						placeholder="请输入号码，多个号码用逗号、空格或换行分隔" :rows="10"></el-input>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="closeBatchAddDialog">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="submitBatchAdd">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="批量删除号码" v-model="batchDeleteVisible" width="600px" @close="closeBatchDeleteDialog">
			<el-form label-width="100px" :model="batchDeleteForm">
				<el-form-item label="来源">
					<el-select size="small" v-model="batchDeleteForm.sourceId" placeholder="请选择来源" style="width: 100%;">
						<el-option v-for="item in sourceList" :key="item.id" :label="item.sourceName" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="号码列表">
					<el-input size="small" type="textarea" v-model="batchDeleteForm.phoneNumbers" 
						placeholder="请输入号码，多个号码用逗号、空格或换行分隔" :rows="10"></el-input>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="closeBatchDeleteDialog">取消</el-button>
					<el-button size="small" type="danger" :class="[theme]" @click="submitBatchDelete">确定删除</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getDijiaNumberPoolNumberList,
		addDijiaNumberPoolNumber,
		batchAddDijiaNumberPoolNumber,
		updateDijiaNumberPoolNumber,
		deleteDijiaNumberPoolNumber,
		batchDeleteDijiaNumberPoolNumber,
		batchDeleteDijiaNumberPoolNumberByPhones,
		getDijiaNumberPoolSourceList
	} from '../api/dijia.js';
	export default {
		name: 'DijiaNumberPoolNumber',
		data() {
			return {
				loading: false,
				theme: localStorage.getItem('theme'),
				theme3: localStorage.getItem('theme3'),
				theme8: localStorage.getItem('theme8'),
				query: {
					sourceId: '',
					phoneNumber: '',
					pageIndex: 1,
					pageSize: 100
				},
				title: '添加',
				tableData: [],
				sourceList: [],
				pageTotal: 0,
				addForm: {
					sourceId: '',
					phoneNumber: ''
				},
				addVisible: false,
			batchAddVisible: false,
			batchAddForm: {
				sourceId: '',
				phoneNumbers: ''
			},
			batchDeleteVisible: false,
			batchDeleteForm: {
				sourceId: '',
				phoneNumbers: ''
			},
			isAdmin: false,
				isCompany: false,
				isAgent: false
			};
		},

		created() {
			let role = localStorage.getItem('ms_role');
			if (role === 'company') {
				this.isCompany = true;
			}
			if (role === 'admin') {
				this.isAdmin = true;
			}
			if (role === 'agent') {
				this.isAgent = true;
			}
			this.getSourceList();
			this.getData();
		},
		methods: {
			getSourceList() {
				getDijiaNumberPoolSourceList().then(res => {
					if (res?.code === 200) {
						this.sourceList = res.data;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getData() {
				if (!this.query.sourceId) {
					this.tableData = [];
					this.pageTotal = 0;
					return;
				}
				this.loading = true;
				getDijiaNumberPoolNumberList(this.query).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData = res.data.list;
						this.pageTotal = res.data.total;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			handleSourceChange() {
				this.query.pageIndex = 1;
				this.query.phoneNumber = '';
				this.getData();
			},
			handlePageChange(val) {
				this.query.pageIndex = val;
				this.getData();
			},
			handleAdd() {
				if (!this.query.sourceId) {
					this.$message.error('请先选择来源');
					return;
				}
				this.title = '添加';
				this.addVisible = true;
				this.addForm = {
					sourceId: this.query.sourceId,
					phoneNumber: ''
				};
			},
			handleBatchAdd() {
				if (!this.query.sourceId) {
					this.$message.error('请先选择来源');
					return;
				}
				this.batchAddVisible = true;
				this.batchAddForm = {
					sourceId: this.query.sourceId,
					phoneNumbers: ''
				};
			},
			handleEdit(row) {
				this.title = '修改';
				this.addVisible = true;
				this.addForm = {
					id: row.id,
					sourceId: row.sourceId,
					phoneNumber: row.phoneNumber
				};
			},
			submitAdd() {
				if (!this.addForm.sourceId) {
					this.$message.error('来源不能为空');
					return;
				}
				if (!this.addForm.phoneNumber) {
					this.$message.error('号码不能为空');
					return;
				}
				let data = {
					sourceId: this.addForm.sourceId,
					phoneNumber: this.addForm.phoneNumber
				};
				addDijiaNumberPoolNumber(data).then(res => {
					if (res?.code === 200) {
						this.$message.success('添加成功');
						this.getData();
					} else {
						this.$message.error(res.message);
					}
					this.addVisible = false;
				});
			},
			submitBatchAdd() {
				if (!this.batchAddForm.sourceId) {
					this.$message.error('来源不能为空');
					return;
				}
				if (!this.batchAddForm.phoneNumbers) {
					this.$message.error('号码不能为空');
					return;
				}
				let data = {
					sourceId: this.batchAddForm.sourceId,
					phoneNumbers: this.batchAddForm.phoneNumbers
				};
				batchAddDijiaNumberPoolNumber(data).then(res => {
					if (res?.code === 200) {
						this.$message.success(res.data);
						this.getData();
					} else {
						this.$message.error(res.message);
					}
					this.batchAddVisible = false;
				});
			},
			submitUpload() {
				let data = {
					id: this.addForm.id,
					phoneNumber: this.addForm.phoneNumber
				};
				updateDijiaNumberPoolNumber(data).then(res => {
					if (res?.code === 200) {
						this.$message.success('修改成功');
						this.getData();
					} else {
						this.$message.error(res.message);
					}
					this.addVisible = false;
				});
			},
			closeDialog() {
				this.addVisible = false;
			},
			closeBatchAddDialog() {
				this.batchAddVisible = false;
			},
			handleDelete(row) {
				this.$confirm('确定要删除吗？', '提示', {
						type: 'warning'
					})
					.then(() => {
						deleteDijiaNumberPoolNumber(row.id).then(res => {
							if (res?.code === 200) {
								this.$message.success('删除成功');
								this.getData();
							} else {
								this.$message.error(res.message);
							}
						});
					})
					.catch(() => {});
			},
			handleBatchDelete() {
				if (!this.query.sourceId) {
					this.$message.error('请先选择来源');
					return;
				}
				this.$confirm('确定要清空该来源下的所有号码吗？此操作不可恢复！', '提示', {
						type: 'warning'
					})
					.then(() => {
						batchDeleteDijiaNumberPoolNumber(this.query.sourceId).then(res => {
							if (res?.code === 200) {
								this.$message.success(res.data);
								this.getData();
							} else {
								this.$message.error(res.message);
							}
						});
					})
					.catch(() => {});
			},
			handleBatchDeleteByPhones() {
				if (!this.query.sourceId) {
					this.$message.error('请先选择来源');
					return;
				}
				this.batchDeleteVisible = true;
				this.batchDeleteForm = {
					sourceId: this.query.sourceId,
					phoneNumbers: ''
				};
			},
			submitBatchDelete() {
				if (!this.batchDeleteForm.sourceId) {
					this.$message.error('来源不能为空');
					return;
				}
				if (!this.batchDeleteForm.phoneNumbers) {
					this.$message.error('号码不能为空');
					return;
				}
				let data = {
					sourceId: this.batchDeleteForm.sourceId,
					phoneNumbers: this.batchDeleteForm.phoneNumbers
				};
				batchDeleteDijiaNumberPoolNumberByPhones(data).then(res => {
					if (res?.code === 200) {
						this.$message.success(res.data);
						this.getData();
					} else {
						this.$message.error(res.message);
					}
					this.batchDeleteVisible = false;
				});
			},
			closeBatchDeleteDialog() {
				this.batchDeleteVisible = false;
			},
		}
	};
</script>

<style scoped>
	.handle-box {
		margin-bottom: 20px;
	}
	.pagination {
		margin-top: 20px;
		display: flex;
		justify-content: center;
	}
</style>
